import { HttpClient } from '@angular/common/http';

import { TranslateLoader } from '@ngx-translate/core';

import { VersionService } from '../services';

import { CustomLoader } from './custom-loader';

export const translateCustomLoader = {
    loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
        deps: [HttpClient, VersionService],
    },
};
